// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__XVR3I","label":"styles_label__W2Qz5","icon":"styles_icon__P8Z5x"};